import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { GivingInfoPage } from '~/components/sections/GivingInfoPage'
import { loadDoubleTheDonation } from '~/lib/browser/loadScript'

export const Route = createFileRoute('/payroll-giving')({
  headers: () => cacheHeaders.content,
  head: () =>
    pageMeta({
      title: 'Payroll Giving',
      description:
        'Support DxE with payroll deductions. Find out if your employer offers a payroll giving program.',
      ogDescription: 'Support DxE with payroll deductions.',
    }),
  component: PayrollGiving,
})

function PayrollGiving() {
  useEffect(() => {
    void loadDoubleTheDonation('payroll')
  }, [])

  return (
    <GivingInfoPage
      title="Payroll Giving"
      subtitle="Support Us with Payroll Deductions"
    >
      <p className="mb-6 text-lg leading-[26px]">
        Thousands of companies offer payroll giving programs that allow you to
        donate automatically from your paycheck and make a difference for
        animals every month.
      </p>
      <div id="dtd-plugin" />
      <p className="mt-6 text-lg leading-[26px]">
        If you have any questions or need help setting up payroll giving, please
        contact DxE&apos;s fundraising team at{' '}
        <a
          href="mailto:donate@friendsofdxe.com"
          className="text-accent underline"
        >
          donate@friendsofdxe.com
        </a>
        .
      </p>
    </GivingInfoPage>
  )
}
